import { z } from 'zod';

export const createTranslationSchema = (allowVariables = false) => {
  if (allowVariables) {
    // When variables are allowed, don't apply defaults as they interfere with variable placeholders
    return z.object({
      x: z.coerce.number(),
      y: z.coerce.number(),
      z: z.coerce.number(),
    });
  }
  return z.object({
    x: z.coerce.number().default(0),
    y: z.coerce.number().default(0),
    z: z.coerce.number().default(0),
  });
};

export const TranslationSchema = createTranslationSchema();

export type Translation = z.infer<typeof TranslationSchema>;
